
const base = {
    logo: 'logo.png',
    //logo : 'images/logo.jpg',
    icons: 'Content/Icons/',
    api_url: 'https://api.akademy.ma',
    domain: 'akademy.ma',
    name: 'Akademy',
    service: 3 // DomainId
}

const icons = {
    add : base.icons+'add.png',
    reload : base.icons+'reload.png',
    minimize : base.icons+'minimize.png',
    maximize : base.icons+'maximize.png',
    salaat : '/images/salaat.png'
}

const contact = {
    theme: {
        red : {c:'rgb(102,0,0)', bc:'rgb(153,0,0)', bgc:'rgba(234,153,153,0.5)'},
        blue : {c:'rgb(7,55,99)', bc:'rgb(11,83,148)', bgc:'rgba(159,197,232,0.5)'},
        orange : {c:'rgb(120,63,4)', bc:'rgb(180,95,6)', bgc:'rgba(249,203,156,0.5)'},
        green : {c:'rgb(39,78,19)', bc:'rgb(56,118,29)', bgc:'rgba(182,215,168,0.5)'}
    }
}

const bank = {
    Company: 'TECH2US',    
    RIB : '366 810 0117109 100050838 01',
    Name: 'BANK AL YOUSR',
}

const getApp = {
    image : 'logo.png',
    url : 'https://akademy.ma/Content/Apps/SetupAkademyApp-25.5.11.msi'
}

const links = {
    facebook : 'https://www.facebook.com/akademy.ma',
    twitter : 'https://twitter.com/akademy_ma',
    instagram : 'https://www.instagram.com/akademy_ma',
    salaat : 'https://salaat.digitalservices.ma',
    telegram : 'https://t.me/akademy_ma',
    whatsapp : 'https://wa.me/+212660800630'
}

export {base, icons, bank, getApp, links}